var exports = {
  "i": "xa15a2ab7--424795--wrapper",
};

module.exports = exports;
